import {memo} from 'react';

import {attachModal} from '~/shared/components/ReduxModal';

import AgeConfirm from './AgeConfirm';

const AgeConfirmModal = ({closeModal, args}) => {
  const {onConfirm} = args;
  const onApprove = () => {
    closeModal();
    onConfirm();
  };

  const onCancel = () => {
    closeModal();
  };

  return <AgeConfirm onApprove={onApprove} onCancel={onCancel} />;
};

const MemoizedAgeConfirmModal = memo(AgeConfirmModal);
MemoizedAgeConfirmModal.mobileBottomSheet = true;
MemoizedAgeConfirmModal.autoHeight = true;

export default attachModal('age_confirm_modal', MemoizedAgeConfirmModal);
